<template>
<div class="statistica__calendar-row">
    <div class="statistica__calendar-row-item">{{year}}</div>
    <div class="statistica__calendar-row-item"
        :class="(items.profit < 0) ? 'color-red' : 'color-green'"
        v-for="(items,index) in statYear" :key="index">{{items.profit}}</div>
    <div class="statistica__calendar-row-item">{{sum}}%</div>
    </div>

</template>
<script>
import { mapGetters } from "vuex";
export default {
    props:{year:{default:2016}},
    data() {
        return {
            stat:{},
            statYear:null,
            sum:null,
            symbol:''
        }
    },
    computed: {
        ...mapGetters({
            getProfit:'accountstat/getMonthProfitStrategy'
        }),
    },
    methods : {
        updateData() {
            let stat = this.getProfit('');
            if (!stat) {
                return;
            }
           this.statYear = profitInMonth(stat, this.year);
            this.sum = getSum(stat, this.year);
        }
    },
    created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
                let stat = this.getProfit(this.symbol);
                 this.stat = stat
                  //this.loading = false;
                  this.updateData();
        });
        this.updateData();
    }
}
function profitInMonth(stat ,year) {
    if (!stat) {
        return;
    }
    let statYear = [];
    for(let i = 0; i < stat.length; i++)
    {
        if(stat[i].year === Number(year))
            statYear.push({month:stat[i].month,
            profit:(stat[i].profit).toFixed(2)})
    }
    if (statYear[statYear.length - 1].month === 11 & statYear.length < 11) {
        let clean = {
            month:'',
            profit:'',
        }
        let count = statYear[0].month
        for(let i = 0; i < count; i++)
            {
                statYear.unshift(clean);
            }
        }
    else {
        let cleaner = {
            month:'',
            profit:'',
        }
        let counter = 11 - statYear[statYear.length - 1].month
        for(let i = 0; i < counter; i++)
            {
                statYear.push(cleaner);
            }
    }
    return statYear;
}
function getSum(stat, year){
            let sum = 0;
             for(let i = 0; i < stat.length; i++)
            {
                if(stat[i].year === Number(year))
                sum+=Number(stat[i].profit)
            }
           return sum.toFixed()
        }

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "statistic-profit-table",
            handler: handler
        }
    });
}
</script>
<style lang="less" scoped>
.statistica__calendar {
    &-row-title {
        display: flex;
        justify-content: space-between;

        &-item {
            font-family: Arimo;
            font-size: 11px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.64;
            letter-spacing: 0.4px;
            text-align: right;
            text-transform: uppercase;
            color: #adc7e1;
            width: 66px;
            flex-grow: 1;
            padding-right: 12px;
            box-sizing: border-box;

            &:first-child {
                font-family: Arimo;
                font-size: 11px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 3.64;
                letter-spacing: 0.4px;
                text-align: right;
                text-transform: uppercase;
                color: #adc7e1;
                width: 66px;
                flex-grow: 1;
                padding-right: 12px;
                box-sizing: border-box;
            }
        }
    }
    &-row {
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #293546;
        &-item {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.15;
            letter-spacing: 0.4px;
            text-align: right;
            color: @colors[green];
            width: 66px;
            flex-grow: 1;
            padding-right: 12px;
            box-sizing: border-box;
        }
    }
}

.statistica__calendar-row-item {
    font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.15;
            letter-spacing: 0.4px;
            text-align: right;
            color: @colors[green];
            width: 66px;
            flex-grow: 1;
            padding-right: 12px;
            box-sizing: border-box;
}
</style>
